import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './notify_list_show.routes';
import SaConfigNotifyListService from '../../../components/api/sa_config_notify_list/sa_config_notify_list.service';
import MailTestService from '../../../components/api/mail_test/mail_test.service';
import SaConfigService from '../../../components/api/sa_config/sa_config.service';
import UniqueValidator from '../../../components/directive/unique_validator/unique_validator.directive';

export class NotifyListShowController {
    /*@ngInject*/
    constructor($state, $scope, $stateParams, $mdDialog, SaConfigNotifyListService, MailTestService, SaConfigService) {
        this.id = $stateParams.id;
        this.state = $state;
        this.emails = [];
        this.newMail = '';
        this.testMailSending   = false;
        this.mailTestSuccessed = false;

        this.NotifyListService = SaConfigNotifyListService;
        this.MailTestService   = MailTestService;
        this.SaConfigService   = SaConfigService;
        this.$mdDialog         = $mdDialog;

        $scope.$watch('$ctrl.newMail', this.resetStatus());
    }

    $onInit() {
        this.SaConfigService.api.show({ id: this.id },
            response => {
                this.location = response.location;
                this.memo     = response.memo;

                this.NotifyListService.api.show({ id: this.id }, response => {
                    this.emails = response.emails;
                });
            },
            err => {
                if(err.status === 404 || err.status === 403) { this.state.go('main.home'); }
            }
        );
    }

    deleteMail(email) {
        let targetIndex = this.emails.indexOf(email);
        this.emails.splice(targetIndex, 1);
        this.NotifyListService.api.update({ id: this.id, emails: this.emails });
    }

    addMail(email) {
        this.emails.push(email);
        this.newMail = '';

        this.NotifyListService.api.update({ id: this.id, emails: this.emails });
    }

    sendTestMail(email) {
        let dialog = {
            confirm: this.$mdDialog.confirm({
                clickOutsideToClose:true,
                title: `${email}宛にテストメールを送信します`,
                ok: '送信する',
                cancel: '戻る'
            }),
            error: this.$mdDialog.alert({
                clickOutsideToClose:true,
                title: 'エラーが発生しました',
                content: 'メールアドレスを確認してください',
                ok: 'OK'
            })
        };

        this.$mdDialog.show(dialog.confirm).then(() => {
            this.testMailSending = true;
            this.MailTestService.api.create(
                {　test_mail: email　},
                okResponse => {
                    this.mailTestSuccessed = true;
                },
                ngResponse => {
                    this.resetStatus();
                    this.$mdDialog.show(dialog.error);
                }
            );
        });
    }

    resetStatus() {
        return () => {
            if(this.testMailSending || this.mailTestSuccessed) {
                this.testMailSending   = false;
                this.mailTestSuccessed = false;
            }
        }
    }
}

export default angular.module('leptonApp.notifyListShow', [uiRouter, SaConfigNotifyListService, MailTestService, SaConfigService, UniqueValidator])
    .config(routing)
    .component('notifyListShow', {
        template: require('./notify_list_show.html'),
        controller: NotifyListShowController
    })
    .name;



// WEBPACK FOOTER //
// ./public/dev/app/notify_list/show/notify_list_show.component.js